"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractSelectOptions = extractSelectOptions;
function extractSelectOptions(selectOptions, options) {
    if (Array.isArray(selectOptions)) {
        return selectOptions;
    }
    else if (selectOptions.hasOwnProperty(options.application)) {
        // @ts-expect-error selectOptions is not an array
        const applicationSelectOptions = selectOptions[options.application];
        if (!applicationSelectOptions) {
            throw new Error(`No select options found for application ${options.application}`);
        }
        return applicationSelectOptions;
    }
    throw new Error(`No select options found for application ${options.application}`);
}
//# sourceMappingURL=extract-select-options.js.map